import React, { useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PurpleColorTestPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <div className="w-full bg-white" data-id="element-3934">
      {/* Back button */}
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-3935">
        <Link to="/" className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-3936">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-3937" />
          <span data-id="element-3938">Go Back</span>
        </Link>
      </div>
      {/* Header with Purple Theme */}
      <header className="w-full bg-white py-4 px-6 md:px-12 border-b border-gray-100" data-id="element-3939">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-3940">
          <div className="flex items-center" data-id="element-3941">
            <a href="/" className="no-underline" data-id="element-3942">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rQktehvNa2Z7NATkWorM3j/Caveo_Update_Logo.png" alt="Caveo Logo" className="h-10 md:h-12" data-id="element-3943" />
            </a>
          </div>
          <nav className="hidden md:flex space-x-6" data-id="element-3944">
            <a href="/product" className="text-[#1A0933] no-underline hover:text-[#9966FF]" data-id="element-3945">
              Product
            </a>
            <a href="/about-us" className="text-[#1A0933] no-underline hover:text-[#9966FF]" data-id="element-3946">
              About Us
            </a>
            <a href="/resources" className="text-[#1A0933] no-underline hover:text-[#9966FF]" data-id="element-3947">
              Resources
            </a>
          </nav>
          <div className="hidden md:flex items-center space-x-4" data-id="element-3948">
            <a href="/login" className="text-[#1A0933] no-underline hover:text-[#9966FF] px-4 py-2 rounded-md" data-id="element-3949">
              Login
            </a>
            <a href="/signup" className="bg-[#3333CC] text-white px-4 py-2 rounded-md font-medium no-underline hover:bg-[#9966FF] transition-colors" data-id="element-3950">
              Start Now
            </a>
          </div>
          <div className="md:hidden" data-id="element-3951">
            <button onClick={toggleMenu} className="text-[#1A0933] focus:outline-none" data-id="element-3952">
              {isMenuOpen ? <XIcon size={24} data-id="element-3953" /> : <MenuIcon size={24} data-id="element-3954" />}
            </button>
          </div>
        </div>
        {/* Mobile menu */}
        {isMenuOpen && <div className="md:hidden fixed inset-0 z-50 bg-white pt-20 px-6" data-id="element-3955">
            <div className="flex flex-col space-y-4" data-id="element-3956">
              <a href="/product" className="text-[#1A0933] text-xl py-2 no-underline hover:text-[#9966FF]" onClick={toggleMenu} data-id="element-3957">
                Product
              </a>
              <a href="/about-us" className="text-[#1A0933] text-xl py-2 no-underline hover:text-[#9966FF]" onClick={toggleMenu} data-id="element-3958">
                About Us
              </a>
              <a href="/resources" className="text-[#1A0933] text-xl py-2 no-underline hover:text-[#9966FF]" onClick={toggleMenu} data-id="element-3959">
                Resources
              </a>
              <div className="pt-4 flex flex-col space-y-4" data-id="element-3960">
                <a href="/login" className="text-[#1A0933] text-center py-2 border border-gray-200 rounded-md no-underline hover:text-[#9966FF]" onClick={toggleMenu} data-id="element-3961">
                  Login
                </a>
                <a href="/signup" className="bg-[#3333CC] text-white text-center py-2 rounded-md font-medium no-underline hover:bg-[#9966FF] transition-colors" onClick={toggleMenu} data-id="element-3962">
                  Start Now
                </a>
              </div>
            </div>
          </div>}
      </header>
      {/* Hero Section with Purple Theme */}
      <section className="w-full bg-[#1A0933] py-16 md:py-24" data-id="element-3963">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-3964">
          <div className="flex flex-col items-center text-center max-w-3xl mx-auto" data-id="element-3965">
            <div className="inline-block bg-[#9966FF] bg-opacity-20 text-[#9966FF] px-4 py-1 rounded-full text-sm font-medium mb-8" data-id="element-3966">
              <span className="flex items-center" data-id="element-3967">
                <span className="mr-2" data-id="element-3968">🚀</span>
                Launching the future of family cyber security
              </span>
            </div>
            <h1 className="mb-6 text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight" data-id="element-3969">
              Protect your family from digital chaos
            </h1>
            <div className="mb-10 max-w-2xl mx-auto" data-id="element-3970">
              <p className="text-gray-300 text-lg" data-id="element-3971">
                Take our free digital safety assessment to see where your
                <br data-id="element-3972" />
                family's at risk and how you can fix it. No email required.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-4 mb-12" data-id="element-3973">
              <Link to="/intro-assessment" className="bg-[#3333CC] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 no-underline hover:bg-[#9966FF]" data-id="element-3974">
                <span data-id="element-3975">Start Now</span>
                <ArrowRightIcon size={18} data-id="element-3976" />
              </Link>
              <a href="/learn-more" className="border border-[#9966FF] text-[#9966FF] px-6 py-3 rounded-md font-medium no-underline hover:bg-[#9966FF] hover:bg-opacity-10 transition-colors" data-id="element-3977">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Features Section with Purple Theme */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-3978">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-3979">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1A0933] mb-6" data-id="element-3980">
            Why people love Caveo
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mb-16" data-id="element-3981">
            Thousands of users trust Caveo to protect their aging parents
            online. Get the tools, skills, and confidence to keep your loved
            ones safe from digital threats.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-12" data-id="element-3982">
            <div className="flex gap-6" data-id="element-3983">
              <div className="flex-shrink-0" data-id="element-3984">
                <div className="w-12 h-12 bg-[#9966FF] bg-opacity-20 rounded-full flex items-center justify-center" data-id="element-3985">
                  <ArrowRightIcon className="w-6 h-6 text-[#3333CC]" data-id="element-3986" />
                </div>
              </div>
              <div data-id="element-3987">
                <h3 className="text-xl font-semibold text-[#1A0933] mb-2" data-id="element-3988">
                  Quick and easy to follow:
                </h3>
                <p className="text-gray-700" data-id="element-3989">
                  Learn how to protect your parents from scams in just 15
                  minutes a day—perfect for any family with seniors, regardless
                  of technical experience.
                </p>
              </div>
            </div>
            <div className="flex gap-6" data-id="element-3990">
              <div className="flex-shrink-0" data-id="element-3991">
                <div className="w-12 h-12 bg-[#9966FF] bg-opacity-20 rounded-full flex items-center justify-center" data-id="element-3992">
                  <ArrowRightIcon className="w-6 h-6 text-[#3333CC]" data-id="element-3993" />
                </div>
              </div>
              <div data-id="element-3994">
                <h3 className="text-xl font-semibold text-[#1A0933] mb-2" data-id="element-3995">
                  Comprehensive protection:
                </h3>
                <p className="text-gray-700" data-id="element-3996">
                  From email scam detection to secure banking setup, we provide
                  all the tools needed to shield your parents from digital
                  fraud.
                </p>
              </div>
            </div>
            <div className="flex gap-6" data-id="element-3997">
              <div className="flex-shrink-0" data-id="element-3998">
                <div className="w-12 h-12 bg-[#9966FF] bg-opacity-20 rounded-full flex items-center justify-center" data-id="element-3999">
                  <ArrowRightIcon className="w-6 h-6 text-[#3333CC]" data-id="element-4000" />
                </div>
              </div>
              <div data-id="element-4001">
                <h3 className="text-xl font-semibold text-[#1A0933] mb-2" data-id="element-4002">
                  Remote monitoring options:
                </h3>
                <p className="text-gray-700" data-id="element-4003">
                  Our app allows you to help manage your parents' digital
                  security even when you can't be there in person.
                </p>
              </div>
            </div>
            <div className="flex gap-6" data-id="element-4004">
              <div className="flex-shrink-0" data-id="element-4005">
                <div className="w-12 h-12 bg-[#9966FF] bg-opacity-20 rounded-full flex items-center justify-center" data-id="element-4006">
                  <ArrowRightIcon className="w-6 h-6 text-[#3333CC]" data-id="element-4007" />
                </div>
              </div>
              <div data-id="element-4008">
                <h3 className="text-xl font-semibold text-[#1A0933] mb-2" data-id="element-4009">
                  Practical and actionable:
                </h3>
                <p className="text-gray-700" data-id="element-4010">
                  Get clear, jargon-free guidance on how to secure devices,
                  recognize scams, and prevent fraud targeting seniors.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials Section with Purple Theme */}
      <section className="w-full bg-[#9966FF] bg-opacity-10 py-16" data-id="element-4011">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4012">
          <div className="text-center mb-12" data-id="element-4013">
            <div className="flex justify-center space-x-2 mb-8" data-id="element-4014">
              <button className="w-3 h-3 rounded-full bg-[#3333CC]" data-id="element-4015"></button>
              <button className="w-3 h-3 rounded-full bg-gray-300" data-id="element-4016"></button>
              <button className="w-3 h-3 rounded-full bg-gray-300" data-id="element-4017"></button>
            </div>
            <blockquote className="text-2xl md:text-3xl font-medium text-[#1A0933] max-w-4xl mx-auto" data-id="element-4018">
              "After my mom nearly fell for a phishing scam, Caveo helped me set
              up proper protections that she could easily understand and use."
            </blockquote>
            <div className="mt-8" data-id="element-4019">
              <p className="text-[#1A0933] font-medium" data-id="element-4020">Michael Roberts</p>
              <p className="text-gray-500 text-sm" data-id="element-4021">
                Son of 72-year-old mother, Ohio
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section with Purple Theme */}
      <section className="w-full bg-[#1A0933] py-16 md:py-24" data-id="element-4022">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4023">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-4024">
            <div className="space-y-6" data-id="element-4025">
              <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-4026">
                Protect your aging parents from digital chaos today!
              </h2>
              <p className="text-lg text-gray-300" data-id="element-4027">
                Take the first step toward safeguarding your parents from scams,
                fraud, and digital threats with our comprehensive protection
                tools.
              </p>
              <div className="pt-4" data-id="element-4028">
                <Link to="/intro-assessment" className="bg-[#3333CC] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center sm:justify-start space-x-2 no-underline hover:bg-[#9966FF] inline-flex" data-id="element-4029">
                  <span data-id="element-4030">Start Now</span>
                  <ArrowRightIcon size={18} data-id="element-4031" />
                </Link>
              </div>
            </div>
            <div className="relative" data-id="element-4032">
              <div className="bg-white p-4 rounded-lg shadow-xl overflow-hidden" data-id="element-4033">
                <img src="https://images.unsplash.com/photo-1591035897819-f4bdf739f446?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Family using digital devices safely" className="w-full h-auto rounded-md" data-id="element-4034" />
                <div className="absolute top-2 left-2 flex space-x-1" data-id="element-4035">
                  <div className="w-3 h-3 bg-red-500 rounded-full" data-id="element-4036"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-full" data-id="element-4037"></div>
                  <div className="w-3 h-3 bg-green-500 rounded-full" data-id="element-4038"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer with Purple Theme */}
      <footer className="w-full bg-white py-12 border-t border-gray-100" data-id="element-4039">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-4040">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-4041">
            <div data-id="element-4042">
              <div className="text-2xl font-bold text-[#3333CC] mb-6" data-id="element-4043">
                Caveo
              </div>
              <ul className="space-y-3" data-id="element-4044">
                <li data-id="element-4045">
                  <a href="/" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-4046">
                    Home
                  </a>
                </li>
                <li data-id="element-4047">
                  <a href="/resources" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-4048">
                    Resources
                  </a>
                </li>
                <li data-id="element-4049">
                  <a href="/support" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-4050">
                    Support center
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-4051">
              <div className="text-lg font-semibold text-[#1A0933] mb-6" data-id="element-4052">
                Legal
              </div>
              <ul className="space-y-3" data-id="element-4053">
                <li data-id="element-4054">
                  <a href="/privacy" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-4055">
                    Privacy policy
                  </a>
                </li>
                <li data-id="element-4056">
                  <a href="/terms" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-4057">
                    Terms and conditions
                  </a>
                </li>
                <li data-id="element-4058">
                  <a href="/subscription" className="text-gray-600 hover:text-[#9966FF] no-underline" data-id="element-4059">
                    Subscription terms
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-4060">
              <div className="text-lg font-semibold text-[#1A0933] mb-6" data-id="element-4061">
                Disclaimer
              </div>
              <p className="text-gray-600 text-sm" data-id="element-4062">
                Caveo as a family protection platform does not monitor private
                communications. Please consult with your family before making
                any safety decisions. There is no bias towards or against any
                online platforms mentioned in this page.
              </p>
            </div>
          </div>
          <div className="mt-12 pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center" data-id="element-4063">
            <div className="mb-4 md:mb-0" data-id="element-4064">
              <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on App Store" className="h-10 inline-block mr-4" data-id="element-4065" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" className="h-10 inline-block" data-id="element-4066" />
            </div>
            <div className="text-sm text-gray-500" data-id="element-4067">
              © 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.
            </div>
          </div>
        </div>
      </footer>
    </div>;
}